module.exports = __webpack_public_path__ + "img/product_22.c8f2f7e.webp";